import React from 'react';
import { Main } from 'fragments';
import { ManagedBillingFragment } from './fragments';

export const ManagedBilling = () => {

    return (
        <Main>
            <ManagedBillingFragment />
        </Main>
    );
};
